import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-autozaki-logo',
  templateUrl: './autozaki-logo.component.html',
  styleUrls: ['./autozaki-logo.component.scss']
})
export class AutozakiLogoComponent {
  @Input() width: number = 400;
  @Input() height: number = 114;
}